var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTrainingProgram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53145 0.699951C1.1498 0.699951 0.000195313 1.84956 0.000195313 3.2312V7.7312C-0.00332031 7.76987 -0.00332031 7.80503 0.000195313 7.8437V39.4C0.000195313 39.8957 0.404492 40.3 0.900195 40.3H44.1002C44.5959 40.3 45.0002 39.8957 45.0002 39.4V7.89995C45.0002 7.87183 45.0002 7.8437 45.0002 7.81558V3.2312C45.0002 1.84956 43.8506 0.699951 42.4689 0.699951H2.53145ZM2.53145 2.49995H42.4689C42.8873 2.49995 43.2002 2.81284 43.2002 3.2312V6.99995H1.8002V3.2312C1.8002 2.81284 2.11309 2.49995 2.53145 2.49995ZM1.8002 8.79995H43.2002V38.5H1.8002V8.79995ZM9.0002 13.3V15.1H36.0002V13.3H9.0002ZM9.0002 20.5V22.3H11.7002V20.5H9.0002ZM15.3002 20.5V22.3H36.0002V20.5H15.3002ZM9.0002 25.9V27.7H11.7002V25.9H9.0002ZM15.3002 25.9V27.7H36.0002V25.9H15.3002ZM9.0002 31.3V33.1H11.7002V31.3H9.0002ZM15.3002 31.3V33.1H36.0002V31.3H15.3002Z",
    fill: "#F9B22D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTrainingProgram);
export default __webpack_public_path__ + "static/media/addTrainingProgram.2fdac00cb90f1a73a8a787e28c0bd0d5.svg";
export { ForwardRef as ReactComponent };